import React from 'react';
import { Alert } from 'react-bootstrap';
import { AcknowledgmentData } from './AcknowledgmentStatusAlerts';
import {
  getLatestAcknowledgmentTime,
  getAcknowledgmentCounts,
} from '../utils/acknowledgmentUtils';

interface AcknowledgmentSummaryProps {
  acknowledgements: AcknowledgmentData[];
  variant?: 'info' | 'light';
  className?: string;
  showLastAcknowledgment?: boolean;
}

export const AcknowledgmentSummary: React.FC<AcknowledgmentSummaryProps> = ({
  acknowledgements,
  variant = 'info',
  className = '',
  showLastAcknowledgment = true,
}) => {
  const { acknowledgedCount, pendingCount, totalCount } =
    getAcknowledgmentCounts(acknowledgements);

  if (totalCount === 0) {
    return null;
  }

  return (
    <Alert variant={variant} className={`mb-4 ${className}`}>
      <div className="d-flex align-items-center justify-content-between">
        <div>
          <strong>Acknowledgment Summary:</strong>
          <span className="badge bg-success ms-2">
            {acknowledgedCount} acknowledged
          </span>
          <span className="badge bg-warning ms-2">{pendingCount} pending</span>
          <div className="small text-muted mt-2">
            Total recipients: {totalCount}
            {showLastAcknowledgment && acknowledgedCount > 0 && (
              <span className="ms-2">
                • Last acknowledgment:{' '}
                {getLatestAcknowledgmentTime(acknowledgements)}
              </span>
            )}
          </div>
        </div>
      </div>
    </Alert>
  );
};
